window.responsa = {
  configuration: {
    botId: "65f07cb43882a709b9f89f44",
    rootElementId: "responsa",
    behavior: {
      mode: "contained",
      hideFooterLogo: true
    },
    meta: {
      responsaMeta: {
        userType: "ControCorrente"
      }
    },
    theme: {
      headerIconSrc: null,
      fontSize: "16px",
      fontFamily: "Lato, helvetica, sans-serif",
      customCss: `
        a, a:visited, a:hover, a:active, a:focus {
          color: #004C86;
        }

        .responsa .header {
          display: none;
          background-color: transparent;
          box-shadow: none;
          height: 0;
          justify-content: flex-end;
        }

        .responsa .header .icons.revert {
          margin-top: 60px;
        }

        .responsa.contained {
          background-color: transparent;
          max-height: 100%;
          height: 70vh !important;
          box-shadow: none;
          padding-bottom: 150px;
          padding-top: 50px;
        }


        @media only screen and (max-width: 348px) {
          .responsa.contained {
            background-color: transparent;
            max-height: none;
            width: 100% !important;
            height: 60vh !important;
            box-shadow: none;
            padding-bottom: 10px;
          }
          .chat-container{
            scrollbar-width: thin;
            scrollbar-color: #b0b0b0 transparent;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            width: 100%;
            padding: 1vh 0 0vh 0;
          }
        } 

        @media only screen and (max-width: 768px) {
        
          .history-container {
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            overflow: auto;
            padding: 2px;
            flex: 1;
            --scrollbar-border-radius-size: 1px;
          }

          .history-container {
            padding: 1vh 0 5vh 0;
          }

          .responsa.contained {
            background-color: transparent;
            max-height: none;
            width: 100% !important;
            height: 60vh !important;
            box-shadow: none;
            padding-bottom: 10px;
          }

          .responsa .text-message {
            color: #004C86;
            border-radius: calc(var(--avatar-size)* 0.5);
            border: 1px solid #209bd8;
            line-height: normal;
            font-weight: normal;
            background-color: #fff0;
            font-size: 14px;
          }
        }

        .responsa.chat-container .history-container .message-container.bot {
          margin-top: 0 !important;
        }

        .responsa.chat-container .history-container .message-container.bot .message {
          padding-top: 0;
        }

        .responsa .avatar .bot {
          border: 0;
        }

        .responsa .text-message {
          color: #004C86;
          border-radius: calc(var(--avatar-size) * 0.5);
          border: 1px solid #209bd8;
          line-height: 18.8px;
          font-weight: bold;
          background-color: #fff0;
        }

        .responsa .footer {
          background-color: transparent;
          box-shadow: none;
        }

        .responsa .footer .input-container {
          background-color: transparent;
          box-shadow: none;
          padding: 20px;
          border: 1px solid #209bd8;
          border-radius: var(--avatar-size);
        }

        .responsa.chat-container .footer .input-container .user-input {
          background-color: transparent;
          box-shadow: none;
          border: 0;
          color: #004C86;
        }

        .responsa.chat-container .footer .input-container .user-input::placeholder {
          font-family: 'Lato', sans-serif;
          color: #004C86;
          font-size: 16px;
        }
      `
    }
  }
};

window.responsa.init = function(
  configuration = {},
  channelHostUri = undefined
) {
  if (this.alreadyLaunched || (!this.configuration && !configuration)) {
    return;
  }

  var botId = null;
  var gatewayUri = "https://gateway.channel.prod.goresponsa.com";
  channelHostUri =
    channelHostUri ?? "https://webchat.channel.prod.goresponsa.com";

  this.configuration = Object.assign(
    this.configuration || { gatewayUri },
    configuration || {}
  );

  if (!this.configuration.botId && botId) this.configuration.botId = botId;

  if (this.configuration.gatewayUri == null)
    this.configuration.gatewayUri = gatewayUri;
  this.alreadyLaunched = true;

  var doc = window.document;
  var now = new Date();
  //now.setMinutes(0)
  now.setSeconds(0);
  now.setMilliseconds(0);

  var scriptPolyfillShadowDOM = doc.createElement("script");
  scriptPolyfillShadowDOM.src =
    "https://cdnjs.cloudflare.com/ajax/libs/shadydom/1.9.0/shadydom.min.js";
  doc.body.append(scriptPolyfillShadowDOM);
  var src = "{channel_host_uri}/responsa-webchat.min.js?timestamp={timestamp}"
    .replace("{channel_host_uri}", channelHostUri)
    .replace("{timestamp}", now.getTime());

  var scriptEl = doc.createElement("script");
  scriptEl.src = src;
  scriptEl.defer = true;
  doc.body.append(scriptEl);
  this.loadedScripts = [scriptPolyfillShadowDOM, scriptEl];
}.bind(window.responsa);

window.responsa.unload = function() {
  this.loadedScripts?.forEach(s => {
    s.remove();
  });
  this.alreadyLaunched = false;
}.bind(window.responsa);
